export const NAME_MAX_LENGTH = 100;
export const NAME_REQUIREMENTS_MESSAGE = "Use letters and spaces only; hyphens and apostrophes are also allowed.";

const NAME_PATTERN = /^\p{L}+(?:[ '\u2019-]\p{L}+)*$/u;

export function isValidName(name: string): boolean {
  const normalizedName = name.trim();
  return normalizedName.length > 0 && normalizedName.length <= NAME_MAX_LENGTH && NAME_PATTERN.test(normalizedName);
}
